<template>
  <div class="page-recover">
    <div class="recover-box">
      <div class="recover-logo" @click="$router.push('/')">
        <img src="@/assets/images/layouts/logo_red.png"/>
      </div>
      <div class="recover-container">
        <el-form ref="recoverForm" :model="form" label-width="80px">
          <div class="recover-title">
            <span>Recover Account</span>
          </div>
          <div class="recover-sub-title">
            <span>Create a new password</span>
          </div>
          <div class="password-rules">
            <span>8 characters or more, combining upper and lower-case letters, numbers, and special characters !@#$%^&*</span>
          </div>
          <el-input type="password" placeholder="Password" v-model="form.password" class="recover-input" />
          <el-input type="password" placeholder="Confirm Password" v-model="form.passwordConfirm" class="recover-input" />
          <el-button v-on:click="reset" class="recover-btn" :loading="loadingRecover">Reset Password</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
const md5 = require('md5')
export default {
  name: 'RecoverShow',
  components: {
  },
  data () {
    return {
      uuid: this.$route.params.uuid,
      form: {
        password: '',
        passwordConfirm: ''
      },
      loadingRecover: false
    }
  },
  methods: {
    reset () {
      const { password, passwordConfirm } = this.form
      if (password.length <= 0) {
        this.$message.warning('Password is required')
        return
      }
      const validReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d!@#$%^&*]{8,}$/
      if (!validReg.test(password)) {
        this.$message({ type: 'warning', message: 'Password should have 8 characters or more, combining upper and lower-case letters, numbers, and special characters !@#$%^&*', duration: 10000 })
        return
      }
      if (password !== passwordConfirm) {
        this.$message.warning('Password and confirm password must match')
        return
      }
      this.loadingRecover = true
      const url = '/api/v1/atk_player/users/reset_password/update'
      const that = this
      const body = { uuid: this.uuid, password: md5(password), password_confirm: md5(passwordConfirm) }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$router.push('/login')
          that.$message({ type: 'success', message: 'Set new password successed!', duration: 16000 })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.loadingRecover = false
      }).catch(function (err) {
        console.error('reset', err)
        that.$message({ type: 'error', message: err.msg })
        that.loadingRecover = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-recover {
  padding: 10px;
  min-height: 100vh;
  background: #242A34;
  background-image: url('~@/assets/images/users/bg.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  .recover-box {
    width: 500px;
    margin: 6% auto 0;
    background-color: rgba(46, 54, 68, 0.4);
    border-radius: 10px;
    color: white;
    padding: 50px;
    .recover-logo {
      cursor: pointer;
      margin-bottom: 20px;
      img {
        width: 150px;
        margin: auto;
      }
    }
    .recover-container {
      padding: 20px;
      border-top: 0;
      color: #666;
      .recover-title {
        margin-bottom: 36px;
        text-align: center;
        color: $theme;
        font-size: 30px;
        font-weight: 300;
      }
      .recover-sub-title {
        text-align: center;
        color: white;
        font-size: 20px;
        margin-bottom: 30px;
      }
      .password-rules {
        text-align: center;
        font-size: 13px;
        color: #A0A0A0;
        margin-bottom: 10px;
      }
      .recover-input {
        margin-bottom: 26px;
        input {
          color: #C4C4C4;
          background-color: rgba(85,94,102,0.4);
          border-color: #A6ABAF;
          box-shadow: none;
          height: 35px;
          line-height: 35px;
          padding: 5px 6px;
        }
      }
      .recover-btn {
        width: 100%;
        margin-top: 5px;
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.5px;
        background-color: red;
        border-color: red;
        height: 35px;
        min-height: auto;
        padding: 0;
        color: white;
      }
    }
  }
}
</style>
